import styled from 'styled-components';

import { getThemeTransition, getThemeColor } from '@utils/styled';

function getColor({
  $disabled,
  $active,
}: {
  $disabled?: boolean;
  $active?: boolean;
}) {
  if ($active) {
    return getThemeColor('hue.blue');
  }

  if ($disabled) {
    return getThemeColor('bluegrey.80');
  }

  return getThemeColor('bluegrey.15');
}

export const Pill = styled.span<{
  $active?: boolean;
  $disabled?: boolean;
}>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  height: 100%;
  border: 0.2rem solid
    ${({ $active }) =>
      $active ? getThemeColor('hue.blue') : getThemeColor('bluegrey.95')};
  border-radius: ${({ theme }) => theme.borderRadiuses.pill}rem;
  padding-top: 0;
  padding-bottom: 0;
  ${({ theme }) => theme.getFluidSpacing('padding-left', 'equal', 5)}
  ${({ theme }) => theme.getFluidSpacing('padding-right', 'equal', 5)}
  background-color: ${getThemeColor('bluegrey.95')};
  color: ${getColor};
  font-weight: 500;
  ${({ theme }) => theme.getFluidFont('paragraph1')};
  text-align: center;
  text-decoration: none;
  transition: ${getThemeTransition('all')};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};

  a:hover > &,
  a:focus > &,
  a:active > & {
    border-color: ${getThemeColor('hue.blue')};
    background-color: ${getThemeColor('bluegrey.90')};
    color: ${getThemeColor('hue.blue')};
  }
`;
